
const menus = [
	{
		name: 'Home',
		url: '/',
		class: 'home'
	},
	{
		name: '01 Mensagens',
		url: '/mensagens',
		class: 'mensagens'
	},
	{
		name: '2.1 Perfil',
		url: '/quem-somos/perfil',
		class: 'quem-somos'
	},
	{
		name: '2.2 Visão, missão e valores',
		url: '/quem-somos/visao-missao-valores',
		class: 'quem-somos'
	},
	{
		name: '03 Associados',
		url: '/associados',
		class: 'associados'
	},

	{
		name: '04 Governança corporativa',
		url: '/governanca-corporativa/assembleia-geral',
		class: 'governanca-corporativa'
	},
	{
		name: '4.2 Diretoria',
		url: '/governanca-corporativa/diretoria',
		class: 'governanca-corporativa'
	},
	{
		name: '4.3 Conselho Fiscal',
		url: '/governanca-corporativa/conselho-fiscal',
		class: 'governanca-corporativa'
	},
	{
		name: '4.4 Conselho de Ética',
		url: '/governanca-corporativa/conselho-de-etica',
		class: 'governanca-corporativa'
	},
	{
		name: '4.5 Comitê Executivo',
		url: '/governanca-corporativa/comite-executivo',
		class: 'governanca-corporativa'
	},
	{
		name: '4.6 Nossos fóruns',
		url: '/governanca-corporativa/nossos-foruns',
		class: 'governanca-corporativa'
	},

	{
		name: '5.1 Pessoas',
		url: '/pessoas',
		class: 'pessoas'
	},
	{
		name: '5.2 Perfil',
		url: '/pessoas/perfil',
		class: 'pessoas'
	},
	{
		name: '5.3 Qualidade de vida',
		url: '/pessoas/qualidade-de-vida',
		class: 'pessoas'
	},
	{
		name: '5.4 Engajamento',
		url: '/pessoas/engajamento',
		class: 'pessoas'
	},

	{
		name: '6.1 Resultados do plano de ação 2018',
		url: '/estrategia/plano-de-acao',
		class: 'estrategia'
	},
	{
		name: '6.2 Plano de ação 2019',
		url: '/estrategia/curto-prazo',
		class: 'estrategia'
	},
	{
		name: '6.3 ANBIMA +5',
		url: '/estrategia/longo-prazo',
		class: 'estrategia'
	},
	{
		name: '6.4 Relacionamentos',
		url: '/estrategia/relacionamentos',
		class: 'estrategia'
	},

	{
		name: '7.1 Iniciativas',
		url: '/nosso-ano/principais-iniciativas',
		class: 'nosso-ano'
	},
	{
		name: '7.2 Eventos',
		url: '/nosso-ano/eventos',
		class: 'nosso-ano'
	},
	{
		name: '7.3 Investimentos',
		url: '/nosso-ano/investimentos',
		class: 'nosso-ano'
	},

	{
		name: '08 Sobre o relatório',
		url: '/sobre-o-relatorio',
		class: 'sobre'
	},

	{
		name: '09 Sumário GRI',
		url: '/sumario-gri',
		class: 'sumario'
	},

	{
		name: '10 Créditos',
		url: '/creditos',
		class: 'creditos'
	}
];

export { menus };